import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const Box = styled.div.attrs(props => ({ 'data-qa': props.qa }))`
  position: relative;
  margin-bottom: 22.5px;
  padding: 17.5px 22.5px;
  
  ${({ theme }) => css`
    border: 1px solid ${theme.colors.shades[5]};
    background-color: ${theme.colors.shades[7]};
    
    @media ${theme.breakpoints.mobile} {
      margin-bottom: ${theme.spacing[3]};
    }
  `};
`;

Box.displayName = 'Box';

Box.propTypes = {
  children: PropTypes.node.isRequired,
  qa: PropTypes.string
};

Box.defaultProps = {
  qa: undefined
};

/** @component */
export default Box;
